export const DECKGL_SIZE_SCALE = 45
